import React from "react";
import TransparentModal from "../../app/UI/Modal/TransparentModal";
import { closeModal } from "./modalActions";
import { connect } from "react-redux";

import GroupSalesAndCommissionReportSpinner from "../reports/Cachet/GroupSalesAndCommissionReport/GroupSalesAndCommissionReportSpinner";

const actions = {
  closeModal,
};

const groupSalesAndCommissionReportSpinnerModal = ({ closeModal }) => {
  return (
    <TransparentModal modalHeader="Please Wait...." onClose={closeModal}>
      <GroupSalesAndCommissionReportSpinner />
    </TransparentModal>
  );
};

export default connect(
  null,
  actions
)(groupSalesAndCommissionReportSpinnerModal);
